import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TablesDisplayGridRowDataFragmentGql } from './TablesDisplayGridRowDataFragmentGql';

export const VirtualConnectionTablesDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment VirtualConnectionTablesDisplayGridRowDataFragment on VirtualConnectionTable {
  ...TablesDisplayGridRowDataFragment
}
${TablesDisplayGridRowDataFragmentGql}
`;
